/* Everwell ERCO-style layer: header panels, search, mobile sheet, hero scroll, knowledge slider, reveals. */
(function () {
  'use strict';
  document.documentElement.classList.add('ec-js');

  /* ---------------------------------------------------------- header */
  var header = document.querySelector('[data-ech]');
  if (header) {
    var isHome = header.getAttribute('data-home') === 'true';
    var items = Array.prototype.slice.call(header.querySelectorAll('[data-ech-item]'));
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeTimer = null;

    var setOpen = function (item, open) {
      var btn = item.querySelector('.ech__link');
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    /* One white sheet grows out of the bar: --ech-h is the open panel's height; the last panel stays visible
       while the sheet folds away. The height is stepped from script each frame rather than by a CSS transition
       on the custom property, which iPhone Safari does not repaint (the sheet jumped open and shut there). */
    var dim = document.createElement('div');
    dim.className = 'ech-dim';
    document.body.appendChild(dim);
    var lastOpen = null, foldTimer = null;
    /* Panel content motion: moving between menus slides the old content out and the new in, in
       the direction of travel; the first open lifts each column into place one after another. */
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var easeIn = 'cubic-bezier(0.55, 0, 1, 0.45)', easeOut = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var parts = function (item) {
      var pnl = item && item.querySelector('.ech__panel');
      return pnl ? Array.prototype.slice.call(pnl.querySelectorAll('.ech__list, .ech__subs, .ech__cards, .ech__find, .ech__find-links')) : [];
    };
    var animatePanels = function (from, to) {
      if (calm.matches || !to.animate) return;
      if (from && from !== to) {
        var dir = all.indexOf(to) > all.indexOf(from) ? 1 : -1;
        from.classList.add('is-leaving');
        clearTimeout(from._leaveTimer);
        from._leaveTimer = setTimeout(function () { from.classList.remove('is-leaving'); }, 240);
        parts(from).forEach(function (el) {
          // leave from wherever the content is now, so a quick back-and-forth never jumps
          var cs = getComputedStyle(el), now = { transform: cs.transform === 'none' ? 'translateX(0)' : cs.transform, opacity: cs.opacity };
          el.getAnimations().forEach(function (a) { a.cancel(); });
          el.animate([now, { transform: 'translateX(' + (-30 * dir) + 'px)', opacity: 0 }],
            { duration: 200, easing: easeIn, fill: 'forwards' });
        });
        parts(to).forEach(function (el) {
          el.getAnimations().forEach(function (a) { a.cancel(); });
          el.animate([{ transform: 'translateX(' + (30 * dir) + 'px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }],
            { duration: 260, delay: 110, easing: easeOut, fill: 'backwards' });
        });
      } else if (!from) {
        parts(to).forEach(function (el, i) {
          el.getAnimations().forEach(function (a) { a.cancel(); });
          el.animate([{ transform: 'translateY(8px)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }],
            { duration: 260, delay: 40 + i * 30, easing: easeOut, fill: 'backwards' });
        });
      }
    };
    var bezier = function (x1, y1, x2, y2) {
      var at = function (a1, a2, u) { return 3 * a1 * u * (1 - u) * (1 - u) + 3 * a2 * u * u * (1 - u) + u * u * u; };
      return function (t) {
        var lo = 0, hi = 1, u = t;
        for (var i = 0; i < 24; i++) { u = (lo + hi) / 2; if (at(x1, x2, u) < t) lo = u; else hi = u; }
        return at(y1, y2, u);
      };
    };
    var SHEET = {
      menuOpen: [320, 0, bezier(0.16, 1, 0.3, 1)],
      menuClose: [300, 100, bezier(0.55, 0, 0.9, 0.4)],
      findOpen: [500, 0, bezier(0.22, 1, 0.36, 1)],
      findClose: [420, 60, bezier(0.65, 0, 0.35, 1)],
      findFit: [280, 0, bezier(0.22, 1, 0.36, 1)]
    };
    var sheetH = 0, sheetRaf = 0, sheetWait = 0, sheetDone = 0;
    var sheetTo = function (target, how) {
      cancelAnimationFrame(sheetRaf); clearTimeout(sheetWait); clearTimeout(sheetDone);
      var put = function (v) { sheetH = v; header.style.setProperty('--ech-h', v.toFixed(1) + 'px'); };
      if (calm.matches) { put(target); return; }
      var from = sheetH, dur = how[0], ease = how[2], t0 = null;
      sheetWait = setTimeout(function () {
        var step = function (now) {
          if (t0 === null) t0 = now;
          var k = Math.min(1, (now - t0) / dur);
          put(from + (target - from) * ease(k));
          if (k < 1) sheetRaf = requestAnimationFrame(step);
        };
        sheetRaf = requestAnimationFrame(step);
      }, how[1]);
      // if frames stall (background tab, busy phone) land on the end height anyway
      sheetDone = setTimeout(function () { cancelAnimationFrame(sheetRaf); put(target); }, how[1] + dur + 120);
    };
    var find = header.querySelector('[data-ech-find]');
    var searchBtn = header.querySelector('[data-ech-search]');
    var all = find ? items.concat(find) : items;
    var closeAll = function (except) {
      var wasOpen = header.classList.contains('is-open');
      items.forEach(function (it) { if (it !== except) setOpen(it, false); });
      if (find && find !== except) {
        find.classList.remove('is-open');
        if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
      }
      header.classList.toggle('is-open', !!except);
      document.documentElement.classList.toggle('ech-dimmed', !!except);
      clearTimeout(foldTimer);
      if (lastOpen) lastOpen.classList.remove('is-folding');
      if (except) {
        var panel = except.querySelector('.ech__panel');
        animatePanels(wasOpen ? lastOpen : null, except);
        header.classList.remove('is-closing');
        header.classList.toggle('is-switching', wasOpen);
        sheetTo(panel ? panel.offsetHeight : 0, except === find ? SHEET.findOpen : SHEET.menuOpen);
        lastOpen = except;
      } else if (wasOpen) {
        header.classList.add('is-closing');
        header.classList.remove('is-switching');
        sheetTo(0, lastOpen === find ? SHEET.findClose : SHEET.menuClose);
        if (lastOpen) {
          var folding = lastOpen;
          folding.classList.add('is-folding');
          foldTimer = setTimeout(function () { folding.classList.remove('is-folding'); }, 520);
        }
      }
    };

    items.forEach(function (item) {
      var btn = item.querySelector('.ech__link');
      btn.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(open ? item : null);
        setOpen(item, open);
      });
      item.addEventListener('mouseenter', function () {
        if (!hoverable.matches) return;
        clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverable.matches) return;
        closeTimer = setTimeout(function () { closeAll(null); }, 180);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = header.querySelector('.ech__item.is-open .ech__link');
      closeAll(null);
      header.classList.remove('is-searching', 'is-sheet');
      if (open) open.focus();
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) { closeAll(null); header.classList.remove('is-searching'); }
    });

    if (searchBtn && find) searchBtn.addEventListener('click', function () {
      var on = !find.classList.contains('is-open');
      clearTimeout(closeTimer);
      closeAll(on ? find : null);
      find.classList.toggle('is-open', on);
      searchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var q = header.querySelector('#ech-q'); if (q) setTimeout(function () { q.focus({ preventScroll: true }); }, 60); }
    });

    /* Search as you type: Shopify's predictive search fills the panel with matching products, and the sheet
       follows the panel's new height. Enter still runs the full search page. */
    var q = header.querySelector('#ech-q');
    var results = header.querySelector('[data-ech-results]');
    if (q && results && find && window.fetch) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var typing = 0, ctrl = null, lastTerm = '';
      var refit = function () {
        if (!find.classList.contains('is-open')) return;
        var panel = find.querySelector('.ech__panel');
        sheetTo(panel.offsetHeight, SHEET.findFit);
      };
      var show = function (html) {
        results.innerHTML = html;
        results.hidden = !html;
        find.classList.toggle('has-results', !!html);
        q.setAttribute('aria-expanded', html ? 'true' : 'false');
        refit();
      };
      var render = function (term, items) {
        var all = root + 'search?type=product&q=' + encodeURIComponent(term);
        if (!items.length) return '<p class="ech__results-none">No matches for “' + esc(term) + '”. Try a designation such as H07RN-F.</p>';
        return '<ul class="ech__results-list" role="listbox" aria-label="Matching products">' + items.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          var sub = [p.vendor, p.type].filter(Boolean).join(' · ');
          return '<li role="option"><a class="ech__result" href="' + esc(p.url) + '">' +
            '<span class="ech__result-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="60" height="60" loading="lazy">' : '') + '</span>' +
            '<span class="ech__result-text"><span class="ech__result-title">' + esc(p.title) + '</span>' +
            (sub ? '<span class="ech__result-sub">' + esc(sub) + '</span>' : '') + '</span></a></li>';
        }).join('') + '</ul><a class="ech__results-all" href="' + esc(all) + '">See all results for “' + esc(term) + '”<span aria-hidden="true"> →</span></a>';
      };
      var lookup = function () {
        var term = q.value.trim();
        if (term === lastTerm) return;
        lastTerm = term;
        if (ctrl) ctrl.abort();
        if (term.length < 2) { show(''); return; }
        ctrl = window.AbortController ? new AbortController() : null;
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
          if (term !== q.value.trim()) return;
          show(render(term, (d && d.resources && d.resources.results && d.resources.results.products) || []));
        }).catch(function () {});
      };
      q.addEventListener('input', function () { clearTimeout(typing); typing = setTimeout(lookup, 180); });
      q.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' || results.hidden) return;
        var first = results.querySelector('a'); if (first) { e.preventDefault(); first.focus(); }
      });
      results.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = Array.prototype.slice.call(results.querySelectorAll('a')), i = links.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        if (e.key === 'ArrowDown' && links[i + 1]) links[i + 1].focus();
        if (e.key === 'ArrowUp') (links[i - 1] || q).focus();
      });
    }

    /* Panels laid out like belden.com: a level-2 row with its own links shows them in the next column
       (hover with a mouse, tap or click otherwise); the first one shows when a panel opens. The close button
       and a tap on the dimmed page close it - iPad Safari sends no click for taps on plain page content,
       so the dim layer catches them. */
    var showSub = function (btn) {
      var drill = btn.closest('.ech__drill');
      drill.querySelectorAll('[data-ech-sub]').forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        b.classList.toggle('is-on', on);
        var list = document.getElementById(b.getAttribute('data-ech-sub'));
        if (list) list.classList.toggle('is-on', on);
      });
    };
    header.querySelectorAll('.ech__drill').forEach(function (drill) {
      var first = drill.querySelector('[data-ech-sub]');
      if (first) showSub(first);
    });
    header.querySelectorAll('[data-ech-sub]').forEach(function (btn) {
      btn.addEventListener('click', function () { showSub(btn); });
      btn.addEventListener('mouseenter', function () { if (hoverable.matches) showSub(btn); });
      btn.addEventListener('focus', function () { showSub(btn); });
    });
    header.querySelectorAll('[data-ech-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = header.querySelector('.ech__item.is-open .ech__link');
        closeAll(null);
        if (open) open.focus({ preventScroll: true });
      });
    });
    dim.addEventListener('click', function () { closeAll(null); header.classList.remove('is-searching'); });

    var burger = header.querySelector('[data-ech-burger]');
    if (burger) burger.addEventListener('click', function () {
      var on = !header.classList.contains('is-sheet');
      header.classList.toggle('is-sheet', on);
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.style.overflow = on ? 'hidden' : '';
    });

    /* Hide the bar while scrolling down the page, bring it back on a scroll up. A direction only counts once
       the page has travelled a little way that way (24px down, 36px up), so finger jitter, momentum and the
       bounce at either end of the page on phones don't flick it in and out. It stays put near the top and
       while a menu, the search or the mobile sheet is open. */
    var lastY = window.scrollY, travel = 0, ticking = false;
    var setHidden = function (hide) {
      if (header.classList.contains('is-hidden') === hide) return;
      header.classList.toggle('is-hidden', hide);
      document.documentElement.classList.toggle('ech-is-hidden', hide);
    };
    var onHide = function () {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = Math.max(0, Math.min(window.scrollY, max)), dy = y - lastY;
      lastY = y;
      if (!dy) return;
      var busy = header.classList.contains('is-open') || header.classList.contains('is-sheet');
      if (busy || y <= 60) { travel = 0; setHidden(false); return; }
      travel = (travel > 0) === (dy > 0) ? travel + dy : dy;
      if (travel > 24) setHidden(true);
      else if (travel < -36) setHidden(false);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onHide); }
    }, { passive: true });

    if (isHome) {
      var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ------------------------------------------------------ hero arrow */
  document.querySelectorAll('[data-ec-down]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hero = btn.closest('.ec-hero');
      var section = hero && hero.closest('.shopify-section');
      var next = section && section.nextElementSibling;
      if (!next) return;
      var top = next.getBoundingClientRect().top + window.scrollY;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* -------------------------------------------------- knowledge slider */
  document.querySelectorAll('[data-ec-slider]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-ec-track]');
    var prev = wrap.querySelector('[data-ec-prev]');
    var next = wrap.querySelector('[data-ec-next]');
    var bars = Array.prototype.slice.call(wrap.querySelectorAll('[data-ec-bars] i'));
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var step = function () { return cards[0] ? cards[0].getBoundingClientRect().width + 12 : 300; };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var idx = Math.round(track.scrollLeft / step());
      bars.forEach(function (b, i) { b.classList.toggle('is-on', i === idx); });
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------------------------------------------------------- reveals */
  var reveals = document.querySelectorAll('.ec-reveal');
  if (!('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) {
      // anything already on screen at load shows immediately
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  }
})();
